import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { requestOtpApi, verifyOtpApi } from '../http/http';
import classes from './OtpPage.module.css';

const OTP_LENGTH = 6;
const RESEND_SECONDS = 29;

const OtpPage = () => {
    const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''));
    const [error, setError] = useState('');
    const [timer, setTimer] = useState(RESEND_SECONDS);
    const [loading, setLoading] = useState(false);
    const inputRefs = useRef([]);

    const navigate = useNavigate();
    const location = useLocation();
    const phone = location.state?.phone || 'XXXXXXXXXX';
    const accessToken = location.state?.accessToken || 'XXXXXXXXXX';
    
    const price = location.state?.price || 'xx';
    const selectedPlan = location.state?.selectedPlan || {};
    const [referenceNo, setReferenceNo] = useState(location.state?.referenceNo || '');
    const url= new URL(window.location) 
    const ext_ref=url.searchParams.get("ext_id")
console.log(selectedPlan)
    // Countdown timer
    useEffect(() => {
        if (timer === 0) return;
        const interval = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [timer]);
    console.log(otp)


    const handleChange = (value, index) => {
        if (!/^\d*$/.test(value)) return; 
        console.log(value)
        const newOtp = [...otp];
        newOtp[index] = value; 

        setOtp(newOtp)
        
        setError('');


        // Auto-focus next input
        if (value && index < OTP_LENGTH - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };


    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };


    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, OTP_LENGTH);
        const newOtp = [...otp];
        pasted.split('').forEach((char, i) => { newOtp[i] = char; });
        setOtp(newOtp);
        inputRefs.current[Math.min(pasted.length, OTP_LENGTH - 1)]?.focus();
    };


    const handleVerify = async (e) => {
        e.preventDefault();
        setError('');
        const enteredOtp = otp.join('');
        if (enteredOtp.length < OTP_LENGTH) {
            setError('Invalid OTP, please try again');
            return;
        }
        
        setLoading(true);
        try {
            const response = await verifyOtpApi(phone,selectedPlan.name,price,otp.join(''),accessToken,ext_ref);
            console.log(response.data)

            if (response.data.data && response.data.data.statusCode==="200") {
                // localStorage.setItem('jwt')
                localStorage.setItem('jwt',response.data.data.jwt)
                navigate('/confirmation');
            } else {
                setError(response.data.message || 'Verification failed');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong during verification');
        } finally {
            setLoading(false);
        }
    };

    
    const handleResend = async (e) => {
        e.preventDefault()
        if (timer > 0) return;
        setOtp(Array(OTP_LENGTH).fill(''));
        setError('');
        setLoading(true);

        try {
           const response = await requestOtpApi(phone,selectedPlan.name);
               console.log("OTP Resend Response:", response.data.data);

            if (response.data && response.data.data) {
                setReferenceNo(response.data.data.referenceNo);
            }
            
            setTimer(RESEND_SECONDS);
            inputRefs.current[0]?.focus();
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to resend OTP');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={classes.page_wrapper}>
            {/* Background blobs */}
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                {/* Logo */}
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img
                            src="/assets/images/logo.png"
                            alt="GamePlex logo"
                            className={classes.logo_icon}
                        />
                    </div>
                    <p className={classes.logo_text}>
                        Game<span>Plex</span>
                    </p>
                </div>

                {/* Heading */}
                <div className={classes.heading_area}>
                    <h1 className={classes.title}>Verify Number</h1>
                    <p className={classes.subtitle}>
                        We sent a code to{' '}
                        <span className={classes.phone_highlight}>+960 {phone}</span>
                    </p>
                </div>

                {/* OTP Inputs */}
                <form className={classes.form} onSubmit={handleVerify}>
                    <div className={classes.otp_row} onPaste={handlePaste}>
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                className={classes.otp_input}
                                type="tel"
                                inputMode="numeric"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleChange(e.target.value, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                            />
                        ))}
                    </div>

                    {error && <p className={classes.error_msg}>{error}</p>}

                    <button type="submit" className={classes.submit_btn} disabled={loading}>
                        {loading ? 'Verifying...' : 'Verify & Subscribe'}
                    </button>
                </form>

                {/* Resend */}
                <p className={classes.resend_row}>
                    Didn't receive a code?{' '}
                    <button
                        type="button"
                        className={classes.resend_btn}
                        onClick={handleResend}
                        disabled={timer > 0}
                    >
                        {timer > 0
                            ? <span className={classes.resend_timer}>Resend OTP ({timer}s)</span>
                            : 'Resend OTP'}
                    </button>
                </p>
            </div>
        </div>
    );
};

export default OtpPage;
